import LandingPage from '../pages/draggableLanding';
import AboutPage from '../pages/aboutPage';
import MyWorkPage from '../pages/myWorkPage';
import CollectiblesPage from '../pages/collectiblesPage';
import VirtualPetsPage from '../pages/collections/virtualPets';
import BagCharmKeychains from '../pages/collections/bagCharmKeychains';
import Figurines from '../pages/collections/figurines';
import CardThings from '../pages/collections/cardThings';
import Squishies from '../pages/collections/squishies';
import Hairclips from '../pages/collections/hairclips';
import Portfolio from '../pages/portfoliolinksPage';
import LinksPage from '../pages/linksPage';
import ContactPage from '../pages/contactPage';
import Fun from '../pages/fun';
import OC from '../pages/ocPage';
//sort all pages
export const PAGES = {
    LANDING: 'landing',
    ABOUT: 'about',
    WORK: 'work',
    LINKS: 'links',
    CONTACT: 'contact',
    COLLECTIBLES: 'collectibles',
    VIRTUAL_PETS: 'virtualPets',
    CARD_THINGS: 'cardThings',
    FIGURINES: 'figurines',
    SQUISHIES: 'squishies',
    HAIRCLIPS: 'hairclips',
    BAGCHARMKEYCHAINS: 'bagcharmkeychains',
    PORTFOLIO: 'portfolio',
    FUN: 'fun',
    OC: 'oc'
};
//sort folders by page
export const FOLDERS = {
    MAIN: [
      { id: PAGES.ABOUT, label: 'About Me' },
      { id: PAGES.WORK, label: 'My Work' },
      { id: PAGES.LINKS, label: 'Links' },
      { id: PAGES.CONTACT, label: 'Contact' },
      { id: PAGES.FUN, label: 'What I do for fun' }
    ],
    COLLECTIBLES: [
      { id: PAGES.VIRTUAL_PETS, label: 'Virtual Pets' },
      { id: PAGES.CARD_THINGS, label: 'Card Things' },
      { id: PAGES.FIGURINES, label: 'Figurines'},
      { id: PAGES.HAIRCLIPS, label: 'Hairclips'},
      { id: PAGES.SQUISHIES, label: 'Squishies'},
      { id: PAGES.BAGCHARMKEYCHAINS, label: 'Bag Charms & Keychains'}
    ],
    WORK: [
      { id: PAGES.PORTFOLIO, label: 'Portfolio'}
    ],
    FUN: [
      {id: PAGES.OC, label: 'My Original Characters'},
      {id: PAGES.COLLECTIBLES, label: 'My Collectibles'}
    ]
};
//get init window state for all pages
export const getInitialWindowState = () => ({
    [PAGES.LANDING]: false,
    [PAGES.ABOUT]: false,
    [PAGES.WORK]: false,
    [PAGES.LINKS]: false,
    [PAGES.CONTACT]: false,
    [PAGES.COLLECTIBLES]: false,
    [PAGES.VIRTUAL_PETS]: false,
    [PAGES.CARD_THINGS]: false,
    [PAGES.FIGURINES]: false,
    [PAGES.SQUISHIES]: false,
    [PAGES.HAIRCLIPS]: false,
    [PAGES.BAGCHARMKEYCHAINS]: false,
    [PAGES.PORTFOLIO]: false,
    [PAGES.LINKS]: false,
    [PAGES.FUN]: false,
    [PAGES.OC]: false
});
//soft pages and metadata
export const PAGE_CONFIG = {
  [PAGES.LANDING]: {
    title: "Hello! I'm Anh",
    component: LandingPage,
    folders: FOLDERS.MAIN
  },
  [PAGES.ABOUT]: {
    title: "About Me",
    component: AboutPage
  },
  [PAGES.WORK]: {
    title: "My Work",
    component: MyWorkPage
  },
  [PAGES.COLLECTIBLES]: {
    title: "My Collectibles",
    component: CollectiblesPage,
    folders: FOLDERS.COLLECTIBLES
  },
  [PAGES.VIRTUAL_PETS]: {
    title: "Virtual Pet Collection",
    component: VirtualPetsPage,
  },
  [PAGES.FIGURINES]: {
    title: "Figurine Collection",
    component: Figurines,
  },
  [PAGES.CARD_THINGS]: {
    title: "Card Things Collection",
    component: CardThings,
  },
  [PAGES.SQUISHIES]: {
    title: "Squishy Collection",
    component: Squishies,
  },
  [PAGES.HAIRCLIPS]: {
    title: "Hairclip Collection",
    component: Hairclips,
  },
  [PAGES.BAGCHARMKEYCHAINS]: {
    title: "Bag Charms & Keychains",
    component: BagCharmKeychains,
  },
  [PAGES.PORTFOLIO]: {
    title: "Portfolio Links",
    component: Portfolio
  },
  [PAGES.LINKS]: {
    title: "Links",
    component: LinksPage
  },
  [PAGES.CONTACT]: {
    title: "Contact",
    component: ContactPage
  },
  [PAGES.FUN]:{
    title: "What I do for fun",
    component: Fun
  },
  [PAGES.OC]:{
    title: "My Original Characters",
    component: OC
  }
};